import { create } from "zustand";
import { initialState, TTopicStore } from "./topic.state";
import { createTopicActions } from "./topic.actions";

/**
 * State management store of the V3 search - Topics metadata
 * @example
 * ```
 * const topics = useTopicStore((state) => state.topics)
 * const dispatch = useTopicStore((state) => state.dispatch)
 * dispatch({ type: SearchActions.SET_TOPIC_ITEMS, payload: topicItem })
 * ```
 */
export const useTopicStore = create<TTopicStore>((set, get) => ({
    ...initialState,
    ...createTopicActions(set, get),
}));
